export class TEMPLATES {
  static readonly menu = 1;
  static readonly syncEntityList = 2;
  static readonly maatAuditPlanList = 3;
  static readonly organisationList = 4;
  static readonly organisation = 5;
  static readonly teamList = 6;
  static readonly team = 7;
  static readonly userList = 8;
  static readonly user = 9;
  static readonly inspectionList = 10;
  static readonly batchList = 11;
  static readonly reportList = 12;
  static readonly notificationList = 13;
  static readonly auditList = 14;
  static readonly inspectionCalendar = 15;
  static readonly maatJobList = 16;
  static readonly maatJobItemList = 17;
  static readonly maatNcqList = 18;
  static readonly maatNcq = 19;
  static readonly maatUserList = 20;
  static readonly maatUser = 21;
  static readonly maatSorDescriptionList = 22;
  static readonly maatSorDescription = 23;

  static readonly hiipInspection_InternalExternal = 100;
  static readonly hiipInspection_InternalOnly = 101;
  static readonly hiipInspection_HighRiseBlock = 102;
  static readonly hiipInspection_LowRiseBlock = 103;
  static readonly hiipInspection_MufBlock = 104;
  static readonly hiipInspection_CommunityRoom = 105;
  static readonly hiipInspection_MovableUnit = 106;
  static readonly hiipInspection_SharedLand = 107;
  static readonly hiipInspection_SharedSupportedAccomodation = 108;
  static readonly hiipInspection_LettableBedroom = 109;
  static readonly hiipInspection_FloodInspection = 110;
};

export const TemplateDescriptions: Record<number, string> = {
  [TEMPLATES.menu]: 'Menu',
  [TEMPLATES.syncEntityList]: 'Sync Entity List',
  [TEMPLATES.maatAuditPlanList]: 'MAAT Audit Plan List',
  [TEMPLATES.organisationList]: 'PCR Organisation List',
  [TEMPLATES.organisation]: 'PCR Organisation',
  [TEMPLATES.teamList]: 'PCR Team List',
  [TEMPLATES.team]: 'PCR Team',
  [TEMPLATES.userList]: 'PCR User List',
  [TEMPLATES.user]: 'PCR User',
  [TEMPLATES.inspectionList]: 'PCR Inspection List',
  [TEMPLATES.batchList]: 'PCR Batch List',
  [TEMPLATES.reportList]: 'PCR Report List',
  [TEMPLATES.notificationList]: 'PCR Notification List',
  [TEMPLATES.auditList]: 'PCR Audit List',
  [TEMPLATES.inspectionCalendar]: 'PCR Inspection Calendar',
  [TEMPLATES.maatJobList]: 'MAAT Job List',
  [TEMPLATES.maatJobItemList]: 'MAAT Job Item List',
  [TEMPLATES.maatNcqList]: 'MAAT NCQ List',
  [TEMPLATES.maatNcq]: 'MAAT NCQ',
  [TEMPLATES.maatUserList]: 'MAAT User List',
  [TEMPLATES.maatUser]: 'MAAT User',
  [TEMPLATES.maatSorDescriptionList]: 'MAAT SOR Description List',
  [TEMPLATES.maatSorDescription]: 'MAAT SOR Description',

  [TEMPLATES.hiipInspection_InternalExternal]: 'PCR Inspection (Internal & External)',
  [TEMPLATES.hiipInspection_InternalOnly]: 'PCR Inspection (Internal Only)',
  [TEMPLATES.hiipInspection_HighRiseBlock]: 'PCR Inspection (High Rise Block)',
  [TEMPLATES.hiipInspection_LowRiseBlock]: 'PCR Inspection (Low Rise Block)',
  [TEMPLATES.hiipInspection_MufBlock]: 'PCR Inspection (MUF Block)',
  [TEMPLATES.hiipInspection_CommunityRoom]: 'PCR Inspection (Community Room)',
  [TEMPLATES.hiipInspection_MovableUnit]: 'PCR Inspection (Movable Unit)',
  [TEMPLATES.hiipInspection_SharedLand]: 'PCR Inspection (Shared Land)',
  [TEMPLATES.hiipInspection_SharedSupportedAccomodation]: 'PCR Inspection (Shared Supported Accomodation)',
  [TEMPLATES.hiipInspection_LettableBedroom]: 'PCR Inspection (Lettable Bedroom)',
  [TEMPLATES.hiipInspection_FloodInspection]: 'PCR Inspection (Flood Inspection)'
}

export class VERSIONS {
  static readonly latest = 0;
}
